export const BUG_REPORT_SURVEY_ID = '01928fba-bdf8-0000-9d96-a7d516313905'
